import application from 'application/application';

import moment from 'moment';

import $ from 'jquery';

application.run([
	'$rootScope',
	'$http',
	'$transitions',
	'$state',
	'authentication',
	're',
	'helper',
	'API',
	'templates',
	'environment',
	'permissions',
	'googleAPI',
	'notification',
	'blocked',
	'$timeout',
	'HttpPendingRequestsService',
	'transformDate',
	'$location',
	'$stateParams',

	(
		$rootScope,
		$http,
		$transitions,
		$state,
		authentication,
		re,
		helper,
		API,
		templates,
		environment,
		permissions,
		googleAPI,
		notification,
		blocked,
		$timeout,
		HttpPendingRequestsService,
		transformDate,
		$location,
		$stateParams
	) => {
		/** Recuperar dados do usuário */
		const user = authentication;

		$rootScope.loadingLogin = false;
		$rootScope.Disable = false;
		$rootScope.exitSubMenu = false;
		$rootScope.lastScrollTop = 0;
		$rootScope.delta = 5;
		$rootScope.exitSubMenuNotification = false;

		$rootScope.re = re;

		function rejectTransition(newState) {
			let oldState = sessionStorage.getItem('__oldState__');

			// quando entra nos detalhes do financeiro esta atualizando o estado para o initial, nao consegui achar o motivo indevido, fiz essa validação para resolver de inicio
			if (
				oldState == 'root.default.finances.releases.releasesDetails' &&
				newState == 'root.default.initial'
			)
				return true;

			return false;
		}
		$rootScope.hasAccessUrl = state => {
			let permission;
			let redirect;

			switch (state) {
				case 'root.default.schedule.events':
					permission = 'recordSchedule';
					redirect = '/eventos/prazos';
					break;
				// case 'root.default.processServers':
				// 	permission = 'createSubpoena';
				// 	break;
				case 'root.default.processServers.details':
					permission = 'createSubpoena';
					break;
				case 'root.default.processServers.access':
					permission = 'createSubpoena';
					break;
				case 'root.default.movements.inssDetails':
					permission = 'createProcess';
					break;
				case 'root.default.movements.inss1':
					permission = 'createProcess';
					break;
				case 'root.default.movements.inss':
					permission = 'createProcess';
					break;
				case 'root.default.inssManager':
					permission = 'createProcess';
					break;
				default:
					break;
			}

			if (permission && !permissions.has(permission)) {
				const url = new URL(window.location.href);

				if (permission == 'createSubpoena') {
					window.location.href = url.origin + '/intimacoes';
				} else if (redirect) {
					window.location.href = url.origin + redirect;
				} else {
					window.location.href = url.origin;
				}
			}
		};

		$transitions.onStart(null, async transition => {
			if (rejectTransition(transition.to().name)) return;

			// voltar para tela de login se nao estiver logado, com exceções de
			// if (
			// 	!(
			// 		(transition.to().name == 'root.default.otherwise') |
			// 		(transition.to().name == 'root.login') |
			// 		(transition.to().name == 'root.default.initial') |
			// 		(transition.to().name == 'root.forgotPassword') |
			// 		(transition.to().name == 'root.resetPassword') |
			// 		(transition.to().name == 'root.privacyPolicies') |
			// 		(transition.to().name == 'root.unmarkEmail')
			// 	) &&
			// 	!authentication.isLogged()
			// ) {
			// 	window.location.href = window.location.origin;
			// }

			setTimeout(() => {
				if (window.location.pathname === '/eventos/agendas') {
					document.body.classList.add('overflow-hidden');
				} else {
					document.body.classList.remove('overflow-hidden');
				}
			}, 100);

			$rootScope.hasAccessUrl(transition.to().name);

			$('body').removeClass('modal-open');
			$('body .modal-backdrop').remove();

			$rootScope.prevUserLogged = JSON.parse(
				localStorage.getItem('__authenticationUserData__')
			);

			if (window.location.href.indexOf('access_token?=') > -1)
				localStorage.clear();

			let stateService = transition.router.stateService;

			if (!authentication.isLogged() && transition.params().authentication) {
				transition.abort();

				$state.go('root.login');
			} else if (transition.to().name === 'root.default.initial') {
				transition.abort();

				var rota = 'root.default.movements.list';
				var count = 0;

				['recordPublications', 'createMovements'].forEach((item, index) => {
					if (permissions.has(item) && count == 0) {
						rota = index == 0 ? rota + '2' : rota + '1';
						count += 1;
					}
				});

				if (rota.indexOf('2') != -1) {
					$rootScope.pageSelected = 'Key';
					let params = {};

					$rootScope.datePeriods(params);
				} else {
					await stateService.go(rota);
				}

				sessionStorage.setItem('__allOfAccount__', true);
			}

			sessionStorage.setItem('__oldState__', transition.to().name);

			$rootScope.log();

			/** Limpa as configurações de alertas de confirmação ao fechar. */
			$('#modalAlert')
				.off('hidden.bs.modal')

				.on('hidden.bs.modal', () => {
					delete $rootScope.documentAlertStyle;

					delete $rootScope.documentAlertTitle;

					delete $rootScope.documentAlertButtons;
				});

			$('.busy-overlay').addClass('open');
		});

		$transitions.onFinish(null, () => {
			$('.busy-overlay').removeClass('open');
		});

		$rootScope.signOut = () => {
			$('#screenExit').show();

			$('#contentContent').hide();
			$('#modal-submenu').hide();

			$rootScope.removeAllStorageInfo();

			$('.modal').modal('hide');

			$timeout(() => {
				$rootScope.loadingLogin = false;
				$('#screenExit').hide();

				$('.busy-overlay').removeClass('open');

				sessionStorage.clear();
				localStorage.clear();

				window.location.replace(window.location.origin);
				// window.location.reload(true);
			}, 100);
		};

		$rootScope.removeAllStorageInfo = () => {
			Object.keys(localStorage).forEach(
				value =>
					/^__authentication\w+__$/i.test(value) &&
					localStorage.removeItem(value)
			);

			localStorage.removeItem('__briefcase__');
			localStorage.removeItem('__hasDiaries__');
			localStorage.removeItem('__diaries__');
			localStorage.removeItem('__oldState__');

			sessionStorage.clear();
		};

		$rootScope.callLoginModal = () => {
			$('#modalQuickLogin').modal('show');

			localStorage.removeItem('__acceptedTerms__');
		};

		$rootScope.setPublications = () => {
			sessionStorage.setItem('__allOfAccount__', true);
			sessionStorage.removeItem('__pageMovements__');
			$rootScope.pageSelected = 'Key';
		};

		window.addEventListener('popstate', function(event) {
			if (event.type == 'popstate')
				sessionStorage.removeItem('__pageMovements__');
		});

		$rootScope.deleteItemLocal = () => {
			const itens = [
				'__pageKeyword__',
				'__pageDiary__',
				'__pageNotebook__',
				'__keywordsChecked__',
				'__diarysChecked__',
				'__notebooksChecked__'
			];

			itens.forEach(item => localStorage.removeItem(item));
		};

		$transitions.onBefore(null, transition => {
			HttpPendingRequestsService.cancelAll();

			if (authentication.isLogged()) blocked.updateStatus();

			return transition;
		});

		$transitions.onSuccess(null, transition => {
			let { data, name } = transition.to();

			$timeout(() => {
				let noProcessModule = $rootScope.processMovementsVideo;

				if (name !== 'root.default.addProcesses' && noProcessModule === true) {
					let dataAccessUrl = {
						noAccess: true,
						name: location.href
					};

					localStorage.setItem(
						'__notAccessUrl__',
						JSON.stringify(dataAccessUrl)
					);
				}
			}, 0);

			$timeout(() => {
				const __notAccessUrl__ = JSON.parse(
					localStorage.getItem('__notAccessUrl__')
				);

				if (
					!!__notAccessUrl__ &&
					__notAccessUrl__.noAccess === true &&
					__notAccessUrl__.name &&
					(name === 'root.default.addProcesses' ||
						name === 'root.default.addAutomaticProcesses')
				) {
					location.href = __notAccessUrl__.name;
				}
			}, 0);

			let stateService = transition.router.stateService;

			let blockedUser = localStorage.getItem('__authenticationUserBlocked__');

			if (blockedUser == 'true') {
				if (name.contains('root.default.account')) {
					stateService.go(name);
				} else stateService.go('root.default.blockedUser');
			} else if (
				blockedUser != 'true' &&
				location.pathname.contains('usuario-bloqueado')
			)
				stateService.go('root.default.initial');

			$rootScope.data = data;

			$rootScope.$state = transition;

			clearInterval($rootScope.authenticationCheckTimer);

			$rootScope.authenticationCheckTimer = () => {
				if (
					!authentication.isLogged() &&
					localStorage.getItem('__authenticationToken__')
				) {
					let callingRefreshToken = localStorage.getItem(
							'__authenticationCallingRefreshToken__'
						),
						refreshToken = localStorage.getItem(
							'__authenticationRefreshToken__'
						);

					if (
						refreshToken &&
						refreshToken != 'undefined' &&
						callingRefreshToken !== 'true'
					) {
						localStorage.setItem('__authenticationCallingRefreshToken__', true);
						$http({
							...helper.http(API.refreshToken, 'POST'),
							/*eslint-disable */
							data: {
								grant_type: 'refresh_token',
								refresh_token: localStorage.getItem(
									'__authenticationRefreshToken__'
								)
							},
							messageOverride: {
								error() {}
							}
							/*eslint-enable */
						})
							.then(
								response => {
									let { data } = response,
										callbackFunction = () => {
											localStorage.setItem(
												'__authenticationCallingRefreshToken__',
												false
											);
										};

									const signInData = data.value ? data.value : data;
									const dateToTransform = data.expires_in
										? data.expires_in
										: data.value.expires_in;

									transformDate.formatDate(dateToTransform);

									authentication.signIn(signInData, callbackFunction);
									localStorage.setItem(
										'__authenticationUserImage__',
										data.foto
									);
								},
								() => {
									$('.modal').modal('hide');
									$rootScope.callLoginModal();
								}
							)
							.finally(() => $('.busy-overlay').removeClass('open'));
					} else if (
						callingRefreshToken !== 'true' ||
						refreshToken === 'undefined'
					) {
						// localStorage.clear();
						$rootScope.callLoginModal();
					} else if (
						callingRefreshToken === 'true' ||
						refreshToken !== 'undefined'
					) {
						$('.modal').modal('hide');
						localStorage.removeItem('__acceptedTerms__');
					}
				}
			};
			$rootScope.authenticationCheckTimerInterval = setInterval(
				$rootScope.authenticationCheckTimer,
				1000 / 24
			);

			$('[autofocus]:first').trigger('focus');
		});

		$rootScope.appTemplate = id => {
			return templates[id ? id : authentication.getUserData('idProdutoAdvise')];
		};

		$rootScope.closeNavMobile = () => {
			$('.nav-icons-item').on('click', function() {
				$('.navbar-collapse').collapse('hide');
			});
		};

		$rootScope.attentionMsg = false;

		$rootScope.blockedUser = false;

		$rootScope.treatMovedesk = () => {
			var exist = document.getElementById('btn-chat');

			var element = document.getElementsByClassName(
				'md-chat-widget-container'
			)[0];

			if (!exist && element) {
				var btn = document.createElement('button');
				var icone = document.createElement('span');

				btn.id = 'btn-chat';
				btn.className = 'c-chat close';
				icone.innerHTML = '&times;';

				btn.appendChild(icone);
				element.appendChild(btn);
			}

			$('#btn-chat').on({
				click: () => {
					// eslint-disable-next-line no-undef
					movideskChatWidgetChangeWindowState('minimized');

					if ($state.current.name !== 'root.login')
						$rootScope.counterMovidesk();
				}
			});

			if ($state.current.name !== 'root.login')
				$('.md-chat-widget-btn-wrapper').on({
					click: () => {
						$rootScope.counterMovidesk();
					}
				});
		};

		$rootScope.counterMovidesk = () => {
			clearTimeout($rootScope.timeMovidesk);

			$rootScope.timeMovidesk = setTimeout(() => {
				var exist = document.getElementsByClassName('md-chat-widget-btn-open');

				if (exist.length)
					document.getElementById('md-app-widget').style.visibility = 'hidden';
			}, 10000);
		};

		$rootScope.closeZendeskContainer = () => {
			clearTimeout($rootScope.timeMovidesk);

			var exist = document.getElementsByClassName('md-chat-widget-btn-open');
			var open = document.getElementsByClassName('md-chat-widget-btn-close');

			if (open.length) {
				// eslint-disable-next-line no-undef
				movideskChatWidgetChangeWindowState('minimized');
			}

			[
				'_MODULE_PEOPLE_FILTERS_',
				'_MODULE_FINANCIAL_FILTERS_',
				'_MODULE_MOVEMENTS_FILTERS_',
				'_MODULE_INTIMATION_FILTERS_',
				'_MODULE_SCHEDULE_FILTERS_'
			].forEach(sessionStorage.removeItem.bind(sessionStorage));

			$rootScope.timeMovidesk = setTimeout(() => {
				if (exist.length)
					document.getElementById('md-app-widget').style.visibility = 'hidden';
			}, 10000);
		};

		$rootScope.resetScheduleFilters = () => {
			localStorage.removeItem('__filterSchedule__');

			if ($state.includes('root.default.schedule.events')) {
				const $rangeInput = $('#air-datepicker-range');

				if ($rangeInput && $rangeInput.length) {
					const datepickerInstance = $rangeInput.data('datepicker');

					if (datepickerInstance && datepickerInstance.clear) {
						datepickerInstance.clear();
					}

					if (datepickerInstance && datepickerInstance.opts) {
						datepickerInstance.opts.onSelect('Período', []);
						datepickerInstance.opts.updateDisplay('Período');
					} else {
						$rangeInput.val('Período');
					}
				}

				$rootScope.$broadcast('schedule-reset-to-today');
			}
		};

		$rootScope.openZendesk = () => {
			// environment.name === 'production' ? zE.activate({ hideOnClose: true }) : null
			// if (environment.name === 'production') {
			// }
			$rootScope.treatMovedesk();

			document.getElementById('md-app-widget').style.visibility = 'visible';

			// eslint-disable-next-line no-undef
			movideskChatWidgetChangeWindowState('maximized');

			$('.modal').modal('hide');
		};

		$rootScope.getTemplate = (templates, id) => {
			return templates[id];
		};

		$rootScope.acceptTerms = () => {
			$http({
				...helper.http(API.usersCustomers, 'acceptTerms'),
				method: 'PUT',
				data: {},
				messageOverride: {
					success() {}
				}
			}).then(() => {
				$rootScope.aceitaTermosUso = true;

				setTimeout(() => {
					$rootScope.popUps();
					$rootScope.openOabQuickRegister();
				}, 1000);

				$('#modalTermsUse').modal('hide');

				$rootScope.initVerifyModalSearch();
				$rootScope.openOabQuickRegister();
			});
		};

		$rootScope.verifyTerms = () => {
			const terms = JSON.parse(localStorage.getItem('__acceptedTerms__'));

			if (terms) {
				$rootScope.aceitaTermosUso = terms;
			} else {
				$http({
					...helper.http(API.usersCustomers, 'acceptTermsCurrent'),
					method: 'GET',
					params: {
						...helper.httpFields(['*'])
					}
				}).then(response => {
					const { status, itens } = response.data;

					if (status.codigo === 401) {
						return;
					}

					$rootScope.aceitaTermosUso = itens ? itens[0].aceiteTermosUso : false;

					localStorage.setItem(
						'__acceptedTerms__',
						response.data.itens[0].aceiteTermosUso
					);

					if ($rootScope.aceitaTermosUso) {
						$rootScope.initVerifyModalSearch();
						$rootScope.openOabQuickRegister();
					}

					const colaboradorLogado = localStorage.getItem('__simulatedAccess__');

					if (!$rootScope.aceitaTermosUso && !colaboradorLogado) {
						$rootScope.getTerms();

						setTimeout(() => {
							$('#modalTermsUse')
								.on('show.bs.modal', () => {
									setTimeout(() => {
										$('.oldTerms') &&
											$('.oldTerms').each(function(index, element) {
												$rootScope.getOldTermsUrl(index + 1, element);
											});
									}, 200);
								})
								.modal({
									backdrop: 'static',
									keyboard: false,
									show: true
								});
						}, 200);
					}
				});
			}
		};

		$rootScope.getOldTermsUrl = (version, element) => {
			const getUrlHub = () => {
				if (API.default.hostname.includes('homologacao-')) {
					return 'https://homologacao-plataforma.advise.com.br/';
				} else if (
					API.default.hostname.includes('dev-') ||
					API.default.hostname.includes('localhost')
				) {
					return 'https://dev-plataforma.advise.com.br/';
				} else if (API.default.hostname.includes('sandbox-')) {
					return 'https://sandbox-plataforma.advise.com.br/';
				} else {
					return 'https://plataforma.advise.com.br/';
				}
			};

			let url = getUrlHub() + `termos-e-condicoes/${version}`;
			let newUrl = url;

			element.setAttribute('href', newUrl);
		};

		/** Método que recorda os dias de exclusão dos movimentos da lixeira */
		$rootScope.getDaysDeleteTrash = () => {
			const exist = sessionStorage.getItem('__daysDeleteTrash__');

			if (exist) {
				$rootScope.daysDeleteTrash = exist;

				return;
			}

			$http({
				...helper.http(API.generalParameters, 'GET'),
				params: {
					campos: 'diasExcluirMovLixeira'
				}
			}).then(response => {
				$rootScope.daysDeleteTrash =
					response.data.itens[0].diasExcluirMovLixeira;

				sessionStorage.setItem(
					'__daysDeleteTrash__',
					$rootScope.daysDeleteTrash
				);
			});
		};

		/**********************************************************************/

		/** Validar os ambientes e inserir os scripts */
		if (environment.name === 'production') {
			/** Script RDStation */
			$.getScript(
				'https://d335luupugsy2.cloudfront.net/js/loader-scripts/4650e539-0850-461d-b1ef-cb2e3909a092-loader.js'
			);

			/** Script Hotjar */
			(function(h, o, t, j, a, r) {
				h.hj =
					h.hj ||
					function() {
						(h.hj.q = h.hj.q || []).push(arguments);
					};

				h._hjSettings = {
					hjid: 1783129,
					hjsv: 6
				};

				a = o.getElementsByTagName('head')[0];

				r = o.createElement('script');

				r.async = 1;

				r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;

				a.appendChild(r);
			})(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=');
		}

		/** Script Movidesk */
		(function(d) {
			let script = d.createElement('script'),
				head = d.getElementsByTagName('head')[0];

			script.src = 'https://chat.movidesk.com/Scripts/chat-widget.min.js';

			script.id = 'movidesk-snippet';

			script.defer = 1;

			head.appendChild(script);

			// setTimeout(() => {
			// 	$rootScope.treatMovedesk();
			// }, 1500);

			$(function() {
				$rootScope.treatMovedesk();
			});

			setTimeout(() => {
				const zdWidget = d.getElementById('md-app-widget');

				if ($state.current.name === 'root.login')
					zdWidget && (zdWidget.style.visibility = 'visible');
				else zdWidget && (zdWidget.style.visibility = 'hidden');

				// zE.identify({
				// 	name: (user && user.getUserData('nome')) || '',
				// 	email: (user && user.getUserData('email')) || '',
				// 	organization: 'Advise'
				// });

				if (typeof movideskLogin === 'function')
					// eslint-disable-next-line no-undef
					movideskLogin({
						name: (user && user.getUserData('nome')) || '',
						email: (user && user.getUserData('email')) || '',
						stayConnected: false,
						emptySubject: false,
						startChat: false // Se o startChat for true, o aplicativo irá maximizar e a conversa irá inicializar automaticamente
					});
			}, 2000);
		})(document);

		// verificar se tem uma pesquisa ativa e a pessoa ja participou
		$rootScope.initVerifyModalSearch = () => {
			if (
				typeof $rootScope.exibirCadastroAgil === 'undefined' ||
				!!$rootScope.exibirCadastroAgil
			) {
				setTimeout(() => {
					$rootScope.initVerifyModalSearch();
				}, 1000);

				return;
			}

			const hidePaymentReminder = sessionStorage.getItem(
				'__hide_payment_reminder__'
			);

			if (hidePaymentReminder && hidePaymentReminder == 'true') {
				$http({
					...helper.http(API.modalSearch, 'GET')
				}).then(({ data }) => {
					const modalSearch = data.itens && data.itens[0];

					if (modalSearch && modalSearch.id) {
						$rootScope.modalSearch = modalSearch;

						$rootScope.modalSearch.dataInicio = moment(
							$rootScope.modalSearch.dataInicio
						).format('DD/MM/YYYY');

						$rootScope.modalSearch.dataFim = moment(
							$rootScope.modalSearch.dataFim
						).format('DD/MM/YYYY');

						if (!modalSearch.titulo.contains('[POPUP]')) {
							$rootScope.openModalSearch();
						} else {
							setTimeout(() => {
								$rootScope.openPopupSearch();
							}, 2000);
						}

						return;
					}

					$rootScope.openContactPhoneModal();
				});
			} else {
				sessionStorage.setItem('__show_payment_reminder__', 'true');

				$rootScope.checkPopupNotification();

				setTimeout(() => {
					if (
						$rootScope.paymentRememberData &&
						$rootScope.paymentRememberData.length
					) {
						$rootScope.openModalPaymentRemember();
					}
				}, 5000);
			}
		};

		//FECHAR MODAL DE PESQUISA
		// $rootScope.closeModalSearch = () => {
		// 	$rootScope.exitModalSearch();

		// 	$http({
		// 		...helper.http(API.modalSearch, 'POST'),
		// 		data: {
		// 			idUsuarioCliente: $rootScope.modalSearch.idUsuarioInclusao,
		// 			idModalPesquisa: $rootScope.modalSearch.id,
		// 			flRespondeuPesquisa: false
		// 		},
		// 		messageOverride: {
		// 			success() {}
		// 		}
		// 	});
		// };

		//BOTAO DE PARTICIPAR DA PESQUISA
		$rootScope.participouModalSearch = () => {
			$rootScope.exitModalSearch();

			$http({
				...helper.http(API.modalSearch, 'POST'),
				data: {
					idUsuarioCliente: $rootScope.modalSearch.idUsuarioInclusao,
					idModalPesquisa: $rootScope.modalSearch.id,
					flRespondeuPesquisa: true
				},
				messageOverride: {
					success() {}
				}
			}).finally(() => {
				window.open($rootScope.modalSearch.link, '_blank');
			});
		};

		//ABRIR MODAL DE PESQUISA ANIMAÇÃO
		$rootScope.openModalSearch = () => {
			const hideModalSearch = sessionStorage.getItem('__hide_modal_search__');

			if (hideModalSearch && hideModalSearch == 'true') return;

			if ($(window).width() >= 712) {
				//VERIFICAR PARA MOBILE
				$('#modalViewTemplate').css('display', 'flex');
				setTimeout(() => {
					$('#modalViewTemplate').css('bottom', '120px');
				}, 1000);
			} else {
				$('#modalViewMobileTemplate').modal('show');
				$('#search-modal-mobile').css('bottom', '-900px');

				setTimeout(() => {
					$('#search-modal-mobile').css('bottom', '0');
				}, 500);
			}
		};

		//FECHAR MODAL DE PESQUISA ANIMAÇÃO
		$rootScope.exitModalSearch = () => {
			$('#modalViewTemplate').css('bottom', '-480px');
			$('#search-modal-mobile').css('bottom', '-900px');
			setTimeout(() => {
				$('#modalViewTemplate').css('display', 'none');
				$('#modalViewMobileTemplate').modal('hide');

				$rootScope.openContactPhoneModal();
			}, 1000);

			sessionStorage.setItem('__hide_modal_search__', 'true');
		};

		//ABRIR POPUP DE PESQUISA
		$rootScope.openPopupSearch = () => {
			//VERIFICAR PARA MOBILE
			if ($(window).width() >= 712) {
				$('#modalViewPopupTemplate').css('display', 'flex');
			} else {
				$('#modalViewPopupTemplate').css('display', 'flex');
			}
		};

		$rootScope.exitPopupSearch = () => {
			$('#modalViewPopupTemplate').css('display', 'none');
		};

		$rootScope.openSearchLink = () => {
			$rootScope.participouModalSearch();
			$rootScope.exitPopupSearch();
			window.open($rootScope.modalSearch.link, '_blank');
		};

		$rootScope.treatCompoments = () => {
			['.select2-container--open', '.daterangepicker'].forEach(value => {
				$(value)
					.hide()
					.empty();
			});
		};

		$rootScope.handleCloseAlert = mobile => {
			$(
				'#alerts-container, #view-scope, #menu-top, #ui-view-default, #mobile-attention, #nav-icons-menu'
			).css('transition', '0.5s');

			!mobile &&
				!!$('.trash__can') &&
				$('.trash__can').css('transition', '0.5s');

			var desktop = document.getElementById('alerts-container');

			desktop && desktop.classList.add('closed-attention-desktop');

			var modile = document.getElementById('mobile-attention');

			modile && modile.classList.add('closed-attention-mobile');

			$('#menu-top').css('margin-top', '0');
			$('#view-scope').removeClass('mg-top-calc');
			$('#nav-icons-menu').css('min-height', 'calc(100vh - 56px)');

			!mobile && !!$('.trash__can') && $('.trash__can').css('bottom', '120px');

			if (mobile) {
				$rootScope.attentionMsg = false;
				localStorage.setItem('_attentionMsg', false);
			} else {
				$timeout(() => {
					$rootScope.attentionMsg = false;
					localStorage.setItem('_attentionMsg', false);
				}, 1000);
			}
		};

		$rootScope.getUrlCentralPagamentos = () => {
			if (API.default.hostname.includes('homologacao-')) {
				return 'https://homologacao-pagamentos.advise.com.br/';
			} else if (
				API.default.hostname.includes('dev-') ||
				API.default.hostname.includes('localhost')
			) {
				return 'https://dev-pagamentos.advise.com.br/';
			} else {
				return 'https://pagamentos.advise.com.br/';
			}
		};

		$rootScope.getAcessTicket = () => {
			const token = localStorage.getItem('__authenticationToken__');

			let url = $rootScope.getUrlCentralPagamentos();
			let newUrl = url + 'access_token?=Bearer ' + token;

			newUrl &&
				$('<a>')
					.attr({
						target: '_blank',
						href: newUrl
					})[0]
					.click();

			$rootScope.handleExitSubMenu();
		};

		$rootScope.redirectTo = to => {
			let url = $location.$$url.split('/')[2];
			let isSame = false;

			switch (url) {
				case 'info':
					isSame = Boolean(to == 'info');
					break;
				case 'config':
					isSame = Boolean(to == 'config');
					break;
				case 'atendimento':
					isSame = Boolean(to == 'atendimento');
					break;
				default:
					break;
			}

			if ($location.$$url.split('/')[1] == 'cadastrar-processos-automaticos') {
				isSame = Boolean(to == 'addAutomaticProcesses');
			}

			if (isSame) {
				$rootScope.handleExitSubMenu();

				return;
			}

			if (to == 'addAutomaticProcesses') {
				const newTabUrl = $state.href(
					'root.default.addAutomaticProcesses',
					{},
					{ absolute: true }
				);

				window.open(newTabUrl, '_blank');

				$rootScope.handleExitSubMenu();

				return;
			}

			$rootScope.activeMenu(to);

			to && $state.go(`root.default.account.${to}`, { inherit: false });

			$rootScope.handleExitSubMenu();
		};

		$rootScope.activeMenu = id => {
			if (!$rootScope.hasGroup && id == 'group') return;

			const vars = ['activeInfo', 'activeConfig', 'activeAten'];

			vars.forEach(i => {
				if (id == 'info' && i == 'activeInfo') {
					$rootScope[i] = true;

					return;
				}

				if (id == 'config' && i == 'activeConfig') {
					$rootScope[i] = true;

					return;
				}

				if (id == 'atendimento' && i == 'activeAten') {
					$rootScope[i] = true;

					return;
				}

				$rootScope[i] = false;
			});
		};

		$rootScope.verifyEnvironment = id => {
			switch (id) {
				case '3':
					$rootScope.clonePastePubli();
					break;
				case '2':
					$rootScope.cloneAllPubli();
					break;
				case '4':
					$rootScope.clonePasteProc();
					break;
				case '1':
					$rootScope.cloneAll();
					break;
				default:
					break;
			}

			let urlParams = new URLSearchParams(window.location.search);
			let folderType = urlParams.get('folderType');
			let pasta = urlParams.get('pasta');

			let number = pasta && !folderType ? '4' : folderType ? '3' : id;

			if (pasta && pasta.length && /\D/.test(pasta)) {
				pasta = '';
			}
			if (
				typeof pasta == 'string' &&
				(pasta.length == 0 || pasta.length > 18)
			) {
				number = '9';
			}

			let publicationPaste = document.querySelector('#toggle-publications');
			let processPaste = document.querySelector('#toggle-process');

			if (publicationPaste)
				var isPubli = JSON.parse(
					publicationPaste.getAttribute('aria-expanded')
				);

			if (processPaste)
				var isProc = JSON.parse(processPaste.getAttribute('aria-expanded'));

			var collapse = true;

			if (number == '3' && isProc) {
				var collapse = false;
			} else if (number == '4' && isPubli) var collapse = false;

			if (['3', '4'].includes(number) && collapse)
				$(function() {
					setTimeout(() => {
						$rootScope.toggleCollapse(
							['3'].includes(number) ? 'keyword' : 'process',
							['3'].includes(number) ? 'process' : 'keyword',
							true
						);
					}, 200);
				});
		};

		$rootScope.hasAccess = (permission, redirect) => {
			if (!permissions.has(permission)) {
				const url = new URL(window.location.href);

				if (redirect) {
					window.location.href = url.origin + redirect;
				} else {
					window.location.href = url.origin;
				}
			}
		};

		$rootScope.handleSubMenuNotification = () => {
			if ($rootScope.exitSubMenuNotification) {
				$rootScope.exitSubMenuNotification = false;
				$rootScope.tooltipSubMenuNotification = true;
				$('#modal-notification').removeClass('custom-fade');

				if (
					$rootScope.$$phase !== '$apply' &&
					$rootScope.$$phase !== '$digest'
				) {
					$rootScope.$apply();
				}
			} else {
				$rootScope.exitSubMenuNotification = true;
				$rootScope.tooltipSubMenuNotification = false;
				$('#modal-notification').addClass('custom-fade');
			}
		};

		$rootScope.handleExitSubMenu = () => {
			$rootScope.exitSubMenu = false;
			$('#modal-submenu').removeClass('custom-fade');

			$('#open-modal').removeClass('d-flex');
			$('#open-modal').addClass('d-none');

			$('#close-modal').removeClass('d-none');
			$('#close-modal').addClass('d-flex');
		};

		$rootScope.handleOpenSubMenu = () => {
			$rootScope.exitSubMenu = true;

			$('#modal-submenu').addClass('custom-fade');

			$('#close-modal').removeClass('d-flex');
			$('#close-modal').addClass('d-none');

			$('#open-modal').removeClass('d-none');
			$('#open-modal').addClass('d-flex');
			$rootScope.clickOut();
		};

		$rootScope.handleExitSubMenuPrazo = () => {
			$rootScope.exitSubMenuPrazo = false;
			$('#modal-submenu-prazo').removeClass('custom-fade');

			$('#open-modal').removeClass('d-flex');
			$('#open-modal').addClass('d-none');

			$('#close-modal').removeClass('d-none');
			$('#close-modal').addClass('d-flex');
		};

		$rootScope.handleOpenSubMenuPrazo = () => {
			$rootScope.exitSubMenuPrazo = true;

			$('#modal-submenu-prazo').addClass('custom-fade');

			$('#close-modal').removeClass('d-flex');
			$('#close-modal').addClass('d-none');

			$('#open-modal').removeClass('d-none');
			$('#open-modal').addClass('d-flex');
			$rootScope.clickOutPrazo();
		};

		// Todo componente que tive a classe .click e for clicada nao fechara o submenu se aberto
		$rootScope.clickOutPrazo = () => {
			// menu prazo
			$(document).on('click', function(e) {
				if (!$(e.target).is('.clickout-prazo')) {
					if ($rootScope.exitSubMenu == true)
						$rootScope.handleExitSubMenuPrazo();
				}
			});
		};

		// Todo componente que tive a classe .click e for clicada nao fechara o submenu se aberto
		$rootScope.clickOut = () => {
			$(document).on('click', function(e) {
				if (!$(e.target).is('.clickout')) {
					if ($rootScope.exitSubMenu == true) $rootScope.handleExitSubMenu();
				}
			});
		};

		// Detectar scroll para baixo e feichar sub menu
		$(document).on('scroll', function() {
			var nowScrollTop = $(this).scrollTop();

			if (
				Math.abs($rootScope.lastScrollTop - nowScrollTop) >= $rootScope.delta
			) {
				if (nowScrollTop > $rootScope.lastScrollTop) {
					// SCROLLING DOWN
					if ($rootScope.exitSubMenu) $rootScope.handleExitSubMenu();
				}
				$rootScope.lastScrollTop = nowScrollTop;
			}
		});

		//Monitora e defina o z-index do elementos de select e modais na tela
		const targetElement = document.getElementById('body');
		const elementsToMonitor = [
			{ id: 'menu-top', zIndexWhenOpen: 1030, zIndexWhenClosed: 998 },
			{ id: 'alerts-container', zIndexWhenOpen: 1030, zIndexWhenClosed: 1090 },
			{ id: 'menuBar', zIndexWhenOpen: 1020, zIndexWhenClosed: 997 }
		];

		const observer = new MutationObserver(function(mutations) {
			mutations.forEach(function() {
				elementsToMonitor.forEach(function(elementInfo) {
					const element = document.getElementById(elementInfo.id);

					const classe = document.querySelectorAll('.modal-backdrop');

					let show = false;

					classe.forEach(elemento => {
						if (elemento.classList.contains('show')) {
							show = true;
						}
					});

					if (element) {
						const containsModalOpenClass = targetElement.classList.contains(
							'modal-open'
						);

						if (!containsModalOpenClass && classe && show) {
							targetElement.classList.add('modal-open');
						}

						element.style.zIndex =
							containsModalOpenClass || (classe && show)
								? elementInfo.zIndexWhenOpen
								: elementInfo.zIndexWhenClosed;
					}
				});
			});
		});

		const config = { attributes: true };

		observer.observe(targetElement, config);

		$rootScope.log = () => {
			setTimeout(() => {
				const elementosObservados = document.querySelectorAll('.modal');

				const observeer = new MutationObserver(function(mutations) {
					mutations.forEach(function(mutation) {
						const body = document.getElementById('body');

						if (mutation.target.classList.contains('show')) {
							body.classList.add('modal-open');
						}
					});
				});

				const configg = { attributes: true };

				elementosObservados.forEach(elemento => {
					observeer.observe(elemento, configg);
				});
			}, 3000);
		};
		$rootScope.log();

		function checkURL() {
			if (window.location.pathname === '/eventos/agendas') {
				document.body.classList.add('overflow-hidden');
			} else {
				document.body.classList.remove('overflow-hidden');
			}
		}

		// Verifica a URL quando a página é carregada
		checkURL();

		// Adiciona um ouvinte de eventos para mudanças na URL
		window.onpopstate = checkURL;

		$rootScope.datePeriods = (filters, id) => {
			if ((!filters.dataInicial && $rootScope.pageSelected == 'Key') || !!id) {
				const dataInicial = new Date();

				const I = new Date(
					dataInicial.getFullYear(),
					dataInicial.getMonth(),
					dataInicial.getDate() - 14
				);

				let params = id
					? {}
					: helper.cloneSimpleObject(filters ? filters : $stateParams);

				params.dataInicial = moment(I).format('YYYY-MM-DDT00:00:00');

				const dataFinal = new Date();

				const F = new Date(
					dataFinal.getFullYear(),
					dataFinal.getMonth(),
					dataFinal.getDate()
				);

				params.dataFinal = moment(F).format('YYYY-MM-DDT23:59:59');

				if (!!id) {
					params.pasta = id;
					params.folderType = -2;
					params.p = '3';
				} else if (filters.pasta && !id) {
					params.pasta = filters.pasta;
					params.folderType = -2;
					params.p = '3';
				} else if (!filters.pasta) {
					params.p = '2';
				}

				$rootScope.periodsFolderTypeSelected = false;

				$state.transitionTo(`root.default.movements.list${params.p}`, params, {
					inherit: false,
					reload: `root.default.movements.list${params.p}`
				});
			} else if (filters.folderType || $rootScope.pageSelected == 'Key') {
				let p = $rootScope.pageSelected == 'Key' ? 2 : 3;

				$state.transitionTo(`root.default.movements.list${p}`, filters, {
					inherit: false,
					reload: `root.default.movements.list${p}`
				});
			}
		};

		$rootScope.checkDelayedLoadingToRefresh = () => {
			setTimeout(() => {
				if ($rootScope.loadingLogin) {
					$('#screenExit').show();

					$('#contentContent').hide();
					$('#modal-submenu').hide();

					$rootScope.removeAllStorageInfo();

					$('.modal').modal('hide');

					$timeout(() => {
						$rootScope.loadingLogin = false;
						$('#screenExit').hide();

						$('.busy-overlay').removeClass('open');

						sessionStorage.clear();
						localStorage.clear();

						const url = new URL(window.location.origin);

						url.searchParams.set('_reload', Date.now());
						window.location.replace(url.toString());
					}, 100);
				}
			}, 10000);
		};
	}
]);

// 	<!-- Chat Movidesk -->
// <script type="text/javascript"></script>
// <script src="https://chat.movidesk.com/Scripts/chat-widget.min.js"></script>
// <!-- Chat do Movidesk fim -->
